import { Invitation, InvitationStatusEnum } from '@sr-sdks/api-sdk-axios';
import { Button } from '@sr/ui-library';
import { Tooltip } from 'react-daisyui';
import DateFormatter, { getDateFormat, getTimeFormat } from './DateFormatter';

interface IResendInviteProps {
  invite: Invitation;
  isReadOnly?: boolean;
  onResendInviteClick?: (item: Invitation) => void;
}

const ResendInvite = ({
  invite,
  isReadOnly = false,
  onResendInviteClick,
}: IResendInviteProps) => {
  const buttonText =
    invite.invitationStatus === InvitationStatusEnum.Failed
      ? 'Try Again'
      : 'Resend Invite';
  const lastUpdatedLabel =
    invite.invitationStatus === InvitationStatusEnum.Failed
      ? 'Last attempted:'
      : 'Last sent:';

  return (
    <div className="flex-start flex flex-col justify-center gap-1 px-4">
      <Button
        className="no-underline hover:no-underline disabled:!bg-transparent"
        disabled={isReadOnly}
        variant="link"
        onClick={() => onResendInviteClick?.(invite)}
      >
        {buttonText}
      </Button>
      <Tooltip
        message={`Expires: ${
          invite.expires &&
          getDateFormat(invite.expires, 'short') +
            ', ' +
            getTimeFormat(invite.expires, '12')
        }`}
        className="whitespace-normal font-normal"
        position="top"
      >
        <div className="flex text-sm text-read-only-text opacity-50">
          {lastUpdatedLabel}
          &nbsp;
          {invite.sentAt && <DateFormatter dateString={invite.sentAt} />}
        </div>
      </Tooltip>
    </div>
  );
};

export default ResendInvite;
